{
  "title": "Дозволити доступ до вашого місцезнаходження?",
  "body": "Дозволивши доступ до вашого місцезнаходження, ми можемо переконатись, що ви прибули до об'єкта для реєстрації",
  "disagree": "Відмовити",
  "agree": "Дозволити"
}
